import cx from 'classnames'
import React from 'react'

import styles from './price.module.css'

import { LOADING_TEXT } from '../../constants'

const Price: React.FC<{ isPending?: boolean; className?: string }> = ({
  children,
  isPending = false,
  className = '',
}) => (
  <div aria-label="Price" className={cx(styles.price, { [styles.loadingPrice]: isPending }, className)}>
    {isPending ? LOADING_TEXT : children}
  </div>
)

export default Price
